import { isTokenExpired, logoutAndRedirect } from "./authUtils"

export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token")

  if (!token || isTokenExpired(token)) {
    logoutAndRedirect()
    return
  }

  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  }

  return fetch(url, {
    ...options,
    headers,
  })
}
